import { useLayoutEffect } from 'react';
import * as React from 'react';

import ErrorTemplate, {
  ErrorTemplateProps,
} from '@/components/templates/Error';
import { useLayoutContext } from '@/contexts/layout';

const ErrorPage: React.FC<ErrorTemplateProps> = ({
  apolloError,
  forceErrorCode,
}) => {
  const { setLayoutStyles } = useLayoutContext();
  useLayoutEffect(() => {
    setLayoutStyles({
      showBetButton: false,
    });
  }, []);

  return (
    <ErrorTemplate apolloError={apolloError} forceErrorCode={forceErrorCode} />
  );
};

export default ErrorPage;
